import React from "react";
import { exactMoneyLabel } from "./helpers.mjs";
import {
  catalogRate,
  modelPriceRows,
  modelSearchNote,
} from "./model-prices.mjs";

const dateTime = (value) =>
  value
    ? new Intl.DateTimeFormat("ru-RU", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(value))
    : "—";

export function ModelCatalog({
  prices,
  loading,
  error,
  onRetry,
  productName = "Corplinks",
  embedded = false,
}) {
  const rate = catalogRate;
  return (
    <section className={embedded ? "model-catalog" : "surface corplinks-panel"}>
      <div className="panel-heading">
        <div>
          <p className="eyebrow">{productName} · SI Harness</p>
          <h2>Список моделей</h2>
        </div>
        <button
          className="button ghost small"
          disabled={loading}
          onClick={onRetry}
        >
          Обновить
        </button>
      </div>
      <p className="muted">
        {productName === "TripRoutes"
          ? "Сохранённые тарифы Harness. Кнопка «Обновить» перечитывает каталог; новые модели провайдеров автоматически не добавляются."
          : "Действующие тарифы провайдеров. Цены за 1 млн токенов; поиск указан за 1 тыс. запросов. Фактическая стоимость видна в деталях запуска."}
      </p>
      {productName === "TripRoutes" && (
        <p className="muted">
          DeepSeek: пик — пн–пт, 01:00–04:00 и 06:00–10:00 UTC, кроме праздников
          Китая. Вне пика ставки ниже вдвое. Harness пока рассчитывает DeepSeek
          по верхней ставке; скидка показана справочно. OpenAI GPT-5.6 и GPT-6:
          тарифы для запросов до 272 тыс. входных токенов; длинный контекст
          дороже. Поиск оплачивается дополнительно к токенам. Для Kimi K3 ставка
          записи кэша по TTL пока не подтверждена.
        </p>
      )}
      {error && (
        <div className="inline-problem" role="alert">
          Не удалось загрузить цены: {error.message}
        </div>
      )}
      {loading && !prices.length ? (
        <p className="muted">Загружаем тарифы…</p>
      ) : prices.length ? (
        <div className="table-wrap">
          <table className="model-prices">
            <thead>
              <tr>
                <th>Провайдер</th>
                <th>Модель</th>
                <th>Вход (1М)</th>
                <th>Кэш: чтение</th>
                <th>Выход (1М)</th>
                <th>Кэш: запись</th>
                <th>Веб-поиск (1К)</th>
                {productName === "Готовые решения" && <th>В справке v2</th>}
              </tr>
            </thead>
            <tbody>
              {modelPriceRows(prices, productName === "TripRoutes").map(
                (item) => (
                  <tr key={item.catalogRowId}>
                    <td>{item.provider}</td>
                    <td>
                      <strong>{item.model}</strong>
                      {item.tariffLabel && <small>{item.tariffLabel}</small>}
                      <small>
                        {item.provider} · действует с {dateTime(item.validFrom)}
                      </small>
                      {item.sourceRef && (
                        <small>
                          <a
                            href={item.sourceRef}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Источник тарифа
                          </a>
                        </small>
                      )}
                    </td>
                    <td>
                      {exactMoneyLabel(
                        rate(item, "input_tokens"),
                        item.currency,
                      )}
                    </td>
                    <td>
                      {exactMoneyLabel(
                        rate(item, "cached_input_tokens") ??
                          rate(item, "cached_read_tokens"),
                        item.currency,
                      )}
                    </td>
                    <td>
                      {exactMoneyLabel(
                        rate(item, "output_tokens"),
                        item.currency,
                      )}
                    </td>
                    <td>
                      {rate(item, "cache_write_tokens") != null ? (
                        exactMoneyLabel(
                          rate(item, "cache_write_tokens"),
                          item.currency,
                        )
                      ) : (
                        <>
                          {rate(item, "cache_write_5m_tokens") != null && (
                            <div>
                              5 мин:{" "}
                              {exactMoneyLabel(
                                rate(item, "cache_write_5m_tokens"),
                                item.currency,
                              )}
                            </div>
                          )}
                          {rate(item, "cache_write_1h_tokens") != null && (
                            <div>
                              1 ч:{" "}
                              {exactMoneyLabel(
                                rate(item, "cache_write_1h_tokens"),
                                item.currency,
                              )}
                            </div>
                          )}
                          {rate(item, "cache_write_5m_tokens") == null &&
                            rate(item, "cache_write_1h_tokens") == null &&
                            "Нет сведений"}
                        </>
                      )}
                    </td>
                    <td>
                      {item.provider !== "deepseek" &&
                        exactMoneyLabel(
                          rate(item, "web_search_requests"),
                          item.currency,
                        )}
                      <small>{modelSearchNote(item)}</small>
                    </td>
                    {productName === "Готовые решения" && (
                      <td>
                        {item.counterpartySelection?.researcher1 ? (
                          <>
                            Агент 1
                            {item.counterpartySelection.webSearch && (
                              <small>Поиск документов</small>
                            )}
                          </>
                        ) : (
                          "Не подтверждены ограничения расходов"
                        )}
                      </td>
                    )}
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      ) : (
        !error && <p className="muted">Действующих тарифов нет.</p>
      )}
    </section>
  );
}
